import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UsuarioPerfil } from '../models/misdatos.model';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  private perfilSubject = new BehaviorSubject<UsuarioPerfil | null>(null);
  perfil$ = this.perfilSubject.asObservable();

  constructor() { }

  setPerfil(perfil: UsuarioPerfil | null) {
    this.perfilSubject.next(perfil);
  }
  getPerfil(): UsuarioPerfil | null {
    return this.perfilSubject.value;
  }

}
